import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url } from "./../config.js";
import axios from 'axios';
import { Link } from 'react-router-dom';

function AddPayment() {
  const { user } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    shop_cate: 'all',
    shop_id: 'all',
    bill_date: new Date().toISOString().split('T')[0],
    paid_amount: '',
    payment_type: 'cash',
    sales_notes: '',
    work_id: user?.id || 1
  });
  const [routes, setRoutes] = useState([]);
  const [shops, setShops] = useState([]);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [loading, setLoading] = useState(false);

  // Fetch all shops with routes
  const fetchAllShops = async () => {
    try {
      const response = await axios.get(`${site_url}/shoplist_route`);
      if (response.data.status === 'success') {
        const shops = response.data.shops || [];
        setShops(shops);
        
        // Extract unique routes from shops
        const routeMap = new Map();
        shops.forEach(shop => {
          if (shop.shop_cate && shop.route_name) {
            routeMap.set(shop.shop_cate, {
              id: shop.shop_cate,
              name: shop.route_name
            });
          }
        });
        
        const uniqueRoutes = Array.from(routeMap.values());
        setRoutes(uniqueRoutes);
        
        console.log('Routes loaded:', uniqueRoutes);
      }
    } catch (error) {
      console.error("Error fetching shops", error);
      setShops([]);
      setRoutes([]);
    }
  };

  // Filter shops based on selected route
  const getFilteredShops = () => {
    if (formData.shop_cate === 'all') {
      return shops;
    }
    return shops.filter(shop => shop.shop_cate == formData.shop_cate);
  };

  // Fetch balance amount for selected shop
  const fetchBalanceAmount = async (shopId) => {
    try {
      if (shopId === 'all') {
        setBalanceAmount(0);
        return;
      }
      const response = await axios.get(`${site_url}/allbillpayment/${shopId}`);
      if (response.data.status === 'success') {
        setBalanceAmount(response.data.pending_amount || 0);
      }
    } catch (error) {
      console.error("Error fetching balance amount", error);
    }
  };

  useEffect(() => {
    fetchAllShops();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (name === 'shop_cate') {
      setFormData(prev => ({ ...prev, shop_id: 'all' }));
      setBalanceAmount(0);
    }

    if (name === 'shop_id') {
      fetchBalanceAmount(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${site_url}/add-payment`, formData);
      
      if (response.data.status === 'success') {
        alert('Payment added successfully!');
        // Reset form
        setFormData({
          shop_cate: 'all',
          shop_id: 'all',
          bill_date: new Date().toISOString().split('T')[0],
          paid_amount: '',
          payment_type: 'cash',
          sales_notes: '',
          work_id: user?.id || 1
        });
        setBalanceAmount(0);
        setShops([]);
      } else {
        alert('Error adding payment');
      }
    } catch (error) {
      console.error("Error adding payment", error);
      alert('Error adding payment');
    } finally {
      setLoading(false);
    }
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 2
    }).format(amount);
  };

  return (
    <div id="appCapsule">
      <div className="section mt-4">
        <div className="section-heading">
          <h2 className="title">Add Payment</h2>
        </div>

        <form onSubmit={handleSubmit} className="form-sample">
          <div className="row">
            <div className="col-md-4 mb-3">
              <label className="form-label">Route</label>
              <select 
                name="shop_cate" 
                value={formData.shop_cate}
                onChange={handleInputChange}
                className="form-control" 
                required
              >
                <option value="all">All</option>
                {routes && routes.map((route) => (
                  <option key={route.id} value={route.id}>
                    {route.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Vendors</label>
              <select 
                name="shop_id" 
                value={formData.shop_id}
                onChange={handleInputChange}
                className="form-control" 
                required
              >
                <option value="all">All Customer</option>
                {getFilteredShops().map((shop) => (
                  <option key={shop.shop_id} value={shop.shop_id}>
                     {shop.shop_name} - {shop.shop_name_tamil}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Date</label>
              <input 
                type="date" 
                name="bill_date"
                value={formData.bill_date}
                onChange={handleInputChange}
                className="form-control" 
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Balance Amount</label>
              <input 
                type="text" 
                readOnly 
                className="form-control" 
                value={formatINR(balanceAmount)}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Paid Amount</label>
              <input 
                type="number" 
                name="paid_amount"
                value={formData.paid_amount}
                onChange={handleInputChange}
                step="0.01" 
                min="0" 
                className="form-control" 
                placeholder="Enter Amount Paid"
                required
              />
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Payment Mode</label>
              <select 
                name="payment_type"
                value={formData.payment_type}
                onChange={handleInputChange}
                className="form-control" 
                required
              >
                <option value="cash">Cash</option>
                <option value="bank">Bank</option>
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label className="form-label">Notes</label>
              <textarea 
                name="sales_notes"
                value={formData.sales_notes}
                onChange={handleInputChange}
                className="form-control" 
                rows="3"
                placeholder="Add notes (optional)"
              />
            </div>
          </div>

          <div className="text-end">
            <button 
              type="submit" 
              className="btn btn-danger"
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>
      </div>

      <Sidebar />
      <Footer />
    </div>
  );
}

export default AddPayment;
